const state = {
    companyListNoAction: null,
    companySummaryNoAction: null,
    currentIdNoAction: null,
};

const mutations = {
  SET_COMPANY_SUMMARY_NO_ACTION: (state, companySummaryNoAction) => {
    state.companySummaryNoAction = companySummaryNoAction;
  },
  SET_COMPANY_LIST_NO_ACTION: (state, companyListNoAction) => {
    state.companyListNoAction = companyListNoAction;
  },
  SET_CURRENT_ID_NO_ACTION: (state, currentIdNoAction) => {
    state.currentIdNoAction = currentIdNoAction;
  },
};

const getters = { 
  companySummaryNoAction: (state) => state.companySummaryNoAction,
  companyListNoAction: (state) => state.companyListNoAction,
  currentIdNoAction: (state) => state.currentIdNoAction,
};

const companyListNoAction = {
  state,
  getters,
  mutations,
};

export default companyListNoAction;
